import { defineStore } from 'pinia'
import {ref} from 'vue'

interface Country {
  iso2: string
  name: string
  isEnabled: boolean
}

interface Region {
  id: string
  name: string
  countries: Country[]
}

export const useZoneStore = defineStore('zone', {
  state: () => ({
    regions: [] as Region[],
    activeSave: ref(false),
    forbiddenCountries: ref([] as string[])
  }),

  getters: {
    getRegions: (state) => state.regions,
    getForbiddenCountries: (state) => state.forbiddenCountries,
    getAllCountries: (state) => state.regions.flatMap(region => region.countries),
    getCountryNameByIso2: (state) => (iso2: string) => {
      for (const region of state.regions) {
        const country = region.countries.find(c => c.iso2 === iso2)
        if (country) {
          return country.name
        }
      }
      return ''
    },
    getCountryByIso2: (state) => (iso2: string) => {
      for (const region of state.regions) {
        const country = region.countries.find(c => c.iso2 === iso2)
        if (country) {
          return country
        }
      }
    }
  },

  actions: {
    updateSaveState(val: boolean) {
      this.activeSave = val
    },
    setRegions(regions: Region[]) {
      this.regions = regions
    },
    updateCountryStatus(iso2: string, isEnabled: boolean) {
      for (const region of this.regions) {
        const country = region.countries.find(c => c.iso2 === iso2)
        if (country) {
          country.isEnabled = isEnabled
          break
        }
      }
    },
    batchUpdateCountryStatus(iso2List: string[], isEnabled: boolean) {
      for (const region of this.regions) {
        for (const country of region.countries) {
          if (iso2List.includes(country.iso2)) {
            country.isEnabled = isEnabled
          }
        }
      }
    },
    setForbiddenCountries(forbiddenCountries: string[]) {
      this.forbiddenCountries = forbiddenCountries
    }
  }
})
